// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Global Layout ===== */
.layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  background: linear-gradient(180deg, #0a0f1c 0%, #111827 100%);
  color: #ffffff;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  overflow-x: hidden;
}

/* ===== Header ===== */
.resume-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 4rem;
  margin-bottom: 2rem;
  animation: fadeIn 1.2s ease-in-out;
}

.resume-header h1 {
  font-size: 2.4rem;
  font-weight: 700;
  color: #00aeef;
  letter-spacing: 0.5px;
  margin-bottom: 0.5rem;
}

.resume-header .contact {
  font-size: 1rem;
  color: #cfd8dc;
  margin-bottom: 0.5rem;
}

.resume-header .contact a {
  color: #00aeef;
  text-decoration: none;
  transition: color 0.3s ease;
}

.resume-header .contact a:hover {
  color: #0078d4;
  text-decoration: underline;
}

.resume-header .tagline {
  font-size: 1.1rem;
  font-weight: 500;
  color: #e0e0e0;
  margin-top: 0.5rem;
}

/* ===== Mission Statement ===== */
.mission {
  margin: 1rem 0 2rem;
  text-align: center;
}

.mission-text {
  font-size: 1.3rem;
  font-weight: 600;
  color: #e0e0e0;
  letter-spacing: 0.3px;
}

/* ===== Navigation ===== */
.nav-wrapper {
  margin-bottom: 3rem; /* gives space below buttons */
  text-align: center;
  z-index: 2; /* keeps buttons above background layers */
}

/* ===== Main Content ===== */
.main-content {
  width: 90%;
  max-width: 1000px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 0 25px rgba(0, 174, 239, 0.25);
  backdrop-filter: blur(6px);
  animation: slideUp 1.2s ease-in-out;
  margin-top: 2rem; /* pushes body down below buttons */
  z-index: 1; /* ensures body sits behind buttons */
}


/* ===== Footer ===== */
.footer {
  text-align: center;
  margin-top: auto;
  padding: 2rem 0;
  font-size: 0.9rem;
  color: #b0bec5;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer .tech-stack {
  margin-top: 0.5rem;
  color: #00aeef;
  font-weight: 500;
  letter-spacing: 0.3px;
}

/* ===== Animations ===== */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .resume-header h1 {
    font-size: 1.8rem;
  }

  .main-content {
    padding: 1.5rem;
  }

  .mission-text {
    font-size: 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,6DAA6D;EAC7D,cAAc;EACd,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB,EAAE,8BAA8B;EACnD,kBAAkB;EAClB,UAAU,EAAE,0CAA0C;AACxD;;AAEA,6BAA6B;AAC7B;EACE,UAAU;EACV,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,0BAA0B;EAC1B,mCAAmC;EACnC,gBAAgB,EAAE,mCAAmC;EACrD,UAAU,EAAE,qCAAqC;AACnD;;;AAGA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ===== Global Layout ===== */\n.layout {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 100vh;\n  background: linear-gradient(180deg, #0a0f1c 0%, #111827 100%);\n  color: #ffffff;\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  overflow-x: hidden;\n}\n\n/* ===== Header ===== */\n.resume-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin-top: 4rem;\n  margin-bottom: 2rem;\n  animation: fadeIn 1.2s ease-in-out;\n}\n\n.resume-header h1 {\n  font-size: 2.4rem;\n  font-weight: 700;\n  color: #00aeef;\n  letter-spacing: 0.5px;\n  margin-bottom: 0.5rem;\n}\n\n.resume-header .contact {\n  font-size: 1rem;\n  color: #cfd8dc;\n  margin-bottom: 0.5rem;\n}\n\n.resume-header .contact a {\n  color: #00aeef;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.resume-header .contact a:hover {\n  color: #0078d4;\n  text-decoration: underline;\n}\n\n.resume-header .tagline {\n  font-size: 1.1rem;\n  font-weight: 500;\n  color: #e0e0e0;\n  margin-top: 0.5rem;\n}\n\n/* ===== Mission Statement ===== */\n.mission {\n  margin: 1rem 0 2rem;\n  text-align: center;\n}\n\n.mission-text {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #e0e0e0;\n  letter-spacing: 0.3px;\n}\n\n/* ===== Navigation ===== */\n.nav-wrapper {\n  margin-bottom: 3rem; /* gives space below buttons */\n  text-align: center;\n  z-index: 2; /* keeps buttons above background layers */\n}\n\n/* ===== Main Content ===== */\n.main-content {\n  width: 90%;\n  max-width: 1000px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 2.5rem;\n  box-shadow: 0 0 25px rgba(0, 174, 239, 0.25);\n  backdrop-filter: blur(6px);\n  animation: slideUp 1.2s ease-in-out;\n  margin-top: 2rem; /* pushes body down below buttons */\n  z-index: 1; /* ensures body sits behind buttons */\n}\n\n\n/* ===== Footer ===== */\n.footer {\n  text-align: center;\n  margin-top: auto;\n  padding: 2rem 0;\n  font-size: 0.9rem;\n  color: #b0bec5;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.footer .tech-stack {\n  margin-top: 0.5rem;\n  color: #00aeef;\n  font-weight: 500;\n  letter-spacing: 0.3px;\n}\n\n/* ===== Animations ===== */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 768px) {\n  .resume-header h1 {\n    font-size: 1.8rem;\n  }\n\n  .main-content {\n    padding: 1.5rem;\n  }\n\n  .mission-text {\n    font-size: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
